import PropTypes from "prop-types";
import { useMutation } from "@apollo/client";
import { Card } from "antd";
// @ts-expect-error TODO(typecheck-unify): TS6133 'React' is declared but its value is never read.
import React, { useEffect, useState } from "react";

import { ModelEnum } from "./types";
import { RequirementEditor } from "./editor";
import { RequirementHeader } from "./header";
import { ShowError } from "../../components/error";
import { useRequirements } from "./hooks";
import { getExistedSet, getRemovedSet, getUpdatedSet } from "./utils";
import { MODIFY_HCP_REQUIREMENTS, GET_HCP_REQUIREMENTS } from "./gql";
import ExpTag from "../../components/ExpTag";
import { EXPIRY_TYPE } from "../requirements/constants";
import moment from "moment-timezone";
import { showErrorToast } from "@src/appV2/lib/Notifications";

// @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'hcpId' implicitly has an 'any' type.
function HcpRequirement({ hcpId, agentTMZ }) {
  const [isEditorVisible, showEditor] = useState(false);
  const [modifyHcpRequirements] = useMutation(MODIFY_HCP_REQUIREMENTS);
  // FIXME: Automatically disabled during ESLint config update
  // @ts-expect-error TODO(typecheck-unify): TS6133 'loading' is declared but its value is never read.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { loading, error, data } = useRequirements({
    id: hcpId,
    model: ModelEnum.HCP,
  });
  const { data: { allRequirements } = { allRequirements: [] } } = useRequirements();
  const [nonExpiringRequirements, setNonExpiringRequirements] = useState(new Set());

  useEffect(() => {
    if (!allRequirements?.length) {
      return;
    }
    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'requirement' implicitly has an 'any' type.
    const allNonExpiringRequirements = allRequirements.flatMap((requirement) =>
      requirement.expiryType === EXPIRY_TYPE.DOES_NOT_EXPIRE ? [requirement?._id] : []
    );
    setNonExpiringRequirements(new Set(allNonExpiringRequirements));
  }, [allRequirements]);

  // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'existed' implicitly has an 'any' type.
  const getNextData = (existed, modified) => {
    const existedSet = getExistedSet(existed);
    const removedSet = getRemovedSet(modified);
    const updatedSet = getUpdatedSet(modified);

    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'id' implicitly has an 'any' type.
    const isKept = (id) => !removedSet.has(id) && !updatedSet.has(id);

    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'rec' implicitly has an 'any' type.
    const kept = existed.filter((rec) => isKept(rec._id));
    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'rec' implicitly has an 'any' type.
    const updated = modified.filter((rec) => updatedSet.has(rec._id));
    // @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'rec' implicitly has an 'any' type.
    const added = modified.filter((rec) => !existedSet.has(rec._id));

    return { hcpRequirementList: [...kept, ...updated, ...added] };
  };

  // @ts-expect-error TODO(typecheck-unify): TS7006,TS7031 Parameter 'cache' implicitly has an 'any' type.
  const updateCache = (cache, { data: { modifiedRequirements } }) => {
    const prevData = cache.readQuery({
      query: GET_HCP_REQUIREMENTS,
      variables: { hcpId },
    });
    const nextData = getNextData(prevData.hcpRequirementList, modifiedRequirements);
    cache.writeQuery({
      query: GET_HCP_REQUIREMENTS,
      variables: { hcpId },
      data: nextData,
    });
  };

  // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'newRequirements' implicitly has an 'any' type.
  const handleFinish = async ({ newRequirements, removedRequirements, updatedRequirements }) => {
    showEditor(false);
    if (!newRequirements && !removedRequirements && !updatedRequirements) {
      return;
    }
    const payload = {
      hcpId,
      // FIXME: Automatically disabled during ESLint config update
      // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'expiry' implicitly has an 'any' type.
      // eslint-disable-next-line @typescript-eslint/no-shadow
      newRequirements: newRequirements?.map(({ expiry, ...data }) => ({
        expiry: expiry ? moment.tz(expiry, agentTMZ).endOf("day").utc().format() : null,
        ...data,
      })),
      // FIXME: Automatically disabled during ESLint config update
      // @ts-expect-error TODO(typecheck-unify): TS7031 Binding element 'expiry' implicitly has an 'any' type.
      // eslint-disable-next-line @typescript-eslint/no-shadow
      updatedRequirements: updatedRequirements?.map(({ expiry, ...data }) => ({
        expiry: expiry ? moment.tz(expiry, agentTMZ).endOf("day").utc().format() : null,
        ...data,
      })),
      removedRequirements,
    };

    try {
      await modifyHcpRequirements({
        variables: payload,
        // FIXME: Automatically disabled during ESLint config update
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        update: updateCache as any,
      });
      // FIXME: Automatically disabled during ESLint config update
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_err) {
      showErrorToast("Something went wrong");
    }
  };

  return (
    <Card
      size="small"
      title={<RequirementHeader showEditor={showEditor} title="Fulfilled Requirements" />}
    >
      <ShowError message="Unable to load the requirements" error={error} />
      {/* @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'rec' implicitly has an 'any' type. */}
      {data.hcpRequirementList?.map((rec) => (
        <ExpTag
          popover
          key={rec._id}
          expires={rec.expiry}
          isNonExpiringRequirement={nonExpiringRequirements.has(rec?.requirement?._id)}
        >
          {rec.requirement.name}
        </ExpTag>
      ))}
      <RequirementEditor
        initial={data.hcpRequirementList}
        model={ModelEnum.HCP}
        onFinish={handleFinish}
        visible={isEditorVisible}
      />
    </Card>
  );
}

HcpRequirement.propTypes = {
  hcpId: PropTypes.string.isRequired,
};

export { HcpRequirement };
